<div class="page-container" [class.modal-mode]="isInModal" [testId]="'tenant-employee-container'">
  <div class="employee-tabs-container" *ngIf="hasPublicIpCapability && !isInModal" [testId]="'tenant-employee-tabs-container'">
    <nz-tabset
      [nzSelectedIndex]="selectedTabIndex"
      (nzSelectedIndexChange)="onTabChange($event)"
      [nzAnimated]="false"
      class="employee-tabs"
      [testId]="'tenant-employee-tabset'"
    >
      <nz-tab [nzTitle]="'tenant.employee.tab.members' | i18n" [testId]="'tenant-employee-tab-members'" />
      <nz-tab [nzTitle]="'tenant.employee.tab.ip-range' | i18n" [testId]="'tenant-employee-tab-ip-range'" />
    </nz-tabset>
  </div>

  <ng-container *ngIf="selectedTabIndex === 0 || !hasPublicIpCapability || isInModal">
    <div class="page-topbar" [testId]="'tenant-employee-header-section'">
      <div class="page-header" [testId]="'tenant-employee-title-row'">
        <div class="page-heading" [testId]="'tenant-employee-title-section'">
          <h3 class="page-title" [testId]="'tenant-employee-title'">{{ 'tenant.employee.team-management' | i18n }}</h3>
        </div>
        <div class="page-actions" [testId]="'tenant-employee-action-section'">
          <button
            nz-button
            nzType="primary"
            class="create-button"
            [nzLoading]="addEmployeeLoading"
            (click)="addEmployee()"
            *ngIf="shouldShowAddButton"
            [testId]="'tenant-employee-add-btn'"
          >
            <i nz-icon nzType="plus" *ngIf="!addEmployeeLoading" [testId]="'tenant-employee-add-icon'"></i>
            <span [testId]="'tenant-employee-add-text'">{{ 'tenant.employee.add-employee' | i18n }}</span>
          </button>
        </div>
      </div>

      <div class="topbar-search" [testId]="'tenant-employee-search-container'">
        <div class="topbar-search-row">
          <div class="search-input" [testId]="'tenant-employee-search-input-group'">
            <input
              nz-input
              type="text"
              [placeholder]="'tenant.employee.search-placeholder' | i18n"
              [(ngModel)]="searchKeyword"
              (keydown.enter)="onSearchEnter($event)"
              class="search-input-control"
              [testId]="'tenant-employee-search-input'"
            />
            <button
              type="button"
              class="search-trigger"
              nz-tooltip
              [nzTooltipTitle]="'tenant.employee.search-tooltip' | i18n"
              (click)="search()"
              [testId]="'tenant-employee-search-icon'"
            >
              <i nz-icon nzType="search" class="search-icon"></i>
            </button>
          </div>

          <button
            nz-button
            nzType="default"
            class="batch-search-btn"
            (click)="openBatchModal()"
            [testId]="'tenant-employee-batch-search-btn'"
          >
            <i nz-icon nzType="file-text" [testId]="'tenant-employee-batch-search-icon'"></i>
            <span [testId]="'tenant-employee-batch-search-btn-text'">{{ 'tenant.employee.batch-search-btn-label' | i18n }}</span>
          </button>

          <div class="toolbar-controls" [testId]="'tenant-employee-toolbar-controls'">
            <nz-select
              class="inviter-select"
              [nzPlaceHolder]="'tenant.employee.inviter' | i18n"
              [(ngModel)]="selectedInviterId"
              (ngModelChange)="onInviterChange($event)"
              [nzAllowClear]="true"
              [nzShowSearch]="true"
              [testId]="'tenant-employee-inviter-select'"
            >
              <nz-option
                [nzValue]="null"
                [nzLabel]="'tenant.employee.inviter-all' | i18n"
                [testId]="'tenant-employee-inviter-option-all'"
              />
              <nz-option
                *ngFor="let inviter of inviterList; let idx = index"
                [nzValue]="inviter.accountId"
                [nzLabel]="inviter.name + (inviter.invitedCount !== undefined ? ' (' + inviter.invitedCount + ')' : '')"
                [testId]="'tenant-employee-inviter-option-' + idx"
              />
            </nz-select>

            <button nz-button nzType="default" class="reset-button" (click)="resetSearch()" [testId]="'tenant-employee-reset-btn'">
              <i nz-icon nzType="clear" [testId]="'tenant-employee-reset-icon'"></i>
              <span [testId]="'tenant-employee-reset-text'">{{ 'tenant.employee.reset-tip' | i18n }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="page-scroll" #mobileScrollContainer [testId]="'tenant-employee-page-scroll'">
      <div class="result-meta" [testId]="'tenant-employee-result-meta'">
        <div class="result-count" [testId]="'tenant-employee-result-count'">
          {{ 'tenant.employee.total-records' | i18n: { total: total } }}
        </div>
      </div>

      <div class="batch-feedback-container" *ngIf="isBatchResultActive" [testId]="'tenant-employee-batch-feedback-container'">
        <div class="batch-feedback-bar" [testId]="'tenant-employee-batch-feedback-bar'">
          <div class="feedback-stats" [testId]="'tenant-employee-batch-feedback-stats'">
            <i nz-icon nzType="info-circle" nzTheme="fill" class="feedback-icon"></i>
            <span class="match-text" [testId]="'tenant-employee-batch-matched-text'">
              {{ 'tenant.employee.match-stats' | i18n: { matched: total } }}
            </span>
            <span class="unmatched-text" *ngIf="unmatchedKeys.length > 0" [testId]="'tenant-employee-batch-unmatched-text'">
              {{ 'tenant.employee.unmatched-stats' | i18n: { unmatched: unmatchedKeys.length } }}
            </span>
            <button
              *ngIf="unmatchedKeys.length > 0"
              nz-button
              nzType="link"
              nzSize="small"
              class="toggle-unmatched-btn"
              (click)="toggleUnmatchedPanel()"
              [testId]="'tenant-employee-unmatched-toggle-btn'"
            >
              {{ (showUnmatchedPanel ? 'tenant.employee.collapse-unmatched' : 'tenant.employee.view-unmatched') | i18n }}
              <i nz-icon [nzType]="showUnmatchedPanel ? 'up' : 'down'"></i>
            </button>
          </div>
          <button
            nz-button
            nzType="link"
            nzSize="small"
            class="clear-batch-search-btn"
            (click)="clearBatchSearch()"
            [testId]="'tenant-employee-batch-feedback-clear-btn'"
          >
            <i nz-icon nzType="close-circle"></i>
            {{ 'tenant.employee.clear-search' | i18n }}
          </button>
        </div>

        <div class="unmatched-panel" *ngIf="showUnmatchedPanel && unmatchedKeys.length > 0" [testId]="'tenant-employee-unmatched-panel'">
          <div class="unmatched-panel-header">
            <span class="unmatched-title" [testId]="'tenant-employee-unmatched-title'"
              >{{ 'tenant.employee.unmatched-title' | i18n }} ({{ unmatchedKeys.length }}):</span
            >
          </div>
          <div class="unmatched-tag-list">
            <nz-tag
              *ngFor="let key of unmatchedKeys; let idx = index"
              class="unmatched-tag"
              [testId]="'tenant-employee-unmatched-tag-' + idx"
            >
              {{ key }}
            </nz-tag>
          </div>
        </div>
      </div>

      <div
        class="batch-selection-bar"
        *ngIf="!isSelector && !isPersonalTenant && hasPublicIpCapability && selectedCount > 0"
        [testId]="'tenant-employee-selection-bar'"
      >
        <div class="selection-info">
          <i nz-icon nzType="info-circle" nzTheme="outline" class="selection-icon"></i>
          <span *ngIf="!isSelectAllAcrossPages" [testId]="'tenant-employee-page-selection-text'">
            {{ 'tenant.employee.select-current-page' | i18n: { count: selectedCount } }}
          </span>
          <span *ngIf="isSelectAllAcrossPages" [testId]="'tenant-employee-cross-page-selection-text'">
            {{ 'tenant.employee.all-cross-page-selected' | i18n: { total: selectedCount } }}
          </span>
          <button
            *ngIf="!isSelectAllAcrossPages && total > employeeList.length"
            nz-button
            nzType="link"
            nzSize="small"
            class="cross-page-btn"
            (click)="selectAllAcrossPages()"
            [testId]="'tenant-employee-cross-page-select-btn'"
          >
            {{ 'tenant.employee.select-all-cross-page' | i18n: { total: total } }}
          </button>
        </div>
        <div class="selection-actions" [testId]="'tenant-employee-selection-actions'">
          <ng-container *ngIf="!isPersonalTenant && hasPublicIpCapability">
            <button
              nz-button
              nzType="primary"
              class="batch-allow-btn"
              (click)="openBatchMobileAccessModal(true)"
              [disabled]="batchUpdating"
              [testId]="'tenant-employee-batch-allow-btn'"
            >
              <i nz-icon nzType="check"></i>
              {{ 'tenant.employee.access-allow' | i18n }}
            </button>
            <button
              nz-button
              nzType="default"
              class="batch-disable-btn"
              (click)="openBatchMobileAccessModal(false)"
              [disabled]="batchUpdating"
              [testId]="'tenant-employee-batch-disable-btn'"
            >
              <i nz-icon nzType="stop"></i>
              {{ 'tenant.employee.access-disable' | i18n }}
            </button>
          </ng-container>
          <button
            nz-button
            nzType="link"
            class="batch-clear-selection-btn"
            (click)="clearSelection()"
            [testId]="'tenant-employee-clear-selection-btn'"
          >
            {{ 'tenant.employee.clear-selection' | i18n }}
          </button>
        </div>
      </div>

      <div class="content-section" [testId]="'tenant-employee-content-section'">
        <div class="table-section" [testId]="'tenant-employee-table-section'">
          <nz-spin [nzSpinning]="loading" [nzTip]="'common.loading' | i18n">
            <nz-table
              #employeeTable
              class="table-container"
              nzSize="middle"
              [nzData]="employeeList"
              [nzFrontPagination]="false"
              [nzShowPagination]="false"
              [nzScroll]="tableScrollConfig"
              [nzTableLayout]="'auto'"
              [testId]="'tenant-employee-table'"
            >
              <thead [testId]="'tenant-employee-table-head'">
                <tr [testId]="'tenant-employee-header-row'">
                  <th
                    *ngIf="!isSelector && !isPersonalTenant && hasPublicIpCapability"
                    scope="col"
                    nzWidth="50px"
                    [nzChecked]="isAllCurrentPageSelected"
                    [nzIndeterminate]="isCurrentPageIndeterminate"
                    (nzCheckedChange)="onSelectAllCurrentPage($event)"
                    [testId]="'tenant-employee-header-checkbox'"
                  ></th>
                  <th scope="col" nzWidth="60px" class="text-center" [testId]="'tenant-employee-header-number'">#</th>
                  <th scope="col" [nzWidth]="isSelector ? '320px' : null" [testId]="'tenant-employee-header-name'">
                    {{ 'tenant.employee.name' | i18n }}
                  </th>
                  <th scope="col" nzWidth="120px" [testId]="'tenant-employee-header-role'" *ngIf="shouldShowRoleColumn">
                    {{ 'tenant.employee.role' | i18n }}
                  </th>
                  <th scope="col" nzWidth="200px" [testId]="'tenant-employee-header-inviter-join-time'">
                    {{ 'tenant.employee.inviter-join-time' | i18n }}
                  </th>
                  <th scope="col" nzWidth="100px" [testId]="'tenant-employee-header-status'">
                    {{ 'tenant.employee.status' | i18n }}
                  </th>
                  <th
                    *ngIf="!isSelector && !isPersonalTenant && hasPublicIpCapability"
                    scope="col"
                    nzWidth="152px"
                    class="mobile-access-column"
                    [testId]="'tenant-employee-header-mobile-access'"
                  >
                    {{ 'tenant.employee.mobile-access-control' | i18n }}
                  </th>
                  <th
                    scope="col"
                    [nzWidth]="isSelector ? '80px' : '150px'"
                    [class.text-center]="isSelector"
                    [testId]="'tenant-employee-header-actions'"
                  >
                    {{ 'tenant.employee.actions' | i18n }}
                  </th>
                </tr>
              </thead>
              <tbody [testId]="'tenant-employee-table-body'">
                <tr
                  *ngFor="let employee of employeeTable.data; let i = index; trackBy: trackByEmployee"
                  [class.selectable-row]="isSelector"
                  [class.selected-row]="!isSelector && isRowSelected(employee)"
                  (click)="isSelector && selectRow(employee)"
                  [testId]="'tenant-employee-row-' + i"
                >
                  <td
                    *ngIf="!isSelector && !isPersonalTenant && hasPublicIpCapability"
                    [nzChecked]="isRowSelected(employee)"
                    (nzCheckedChange)="onRowSelect(employee, $event)"
                    [testId]="'tenant-employee-cell-checkbox-' + i"
                  ></td>
                  <td class="text-center" [testId]="'tenant-employee-cell-number-' + i">{{ (pageIndex - 1) * pageSize + i + 1 }}</td>
                  <td [testId]="'tenant-employee-cell-name-' + i">
                    <div class="employee-info">
                      <nz-avatar
                        [nzSrc]="employee.avatarUrl || employee.fallbackAvatarUrl"
                        nzSize="small"
                        class="employee-avatar"
                        (click)="openImageViewer(employee.avatarUrl, employee)"
                        [testId]="'tenant-employee-avatar-' + i"
                      >
                        {{ employee.name?.charAt(0) }}
                      </nz-avatar>
                      <span class="employee-name" nz-tooltip [nzTooltipTitle]="employee.name" [testId]="'tenant-employee-name-' + i">{{
                        employee.name
                      }}</span>
                    </div>
                  </td>
                  <td [testId]="'tenant-employee-cell-role-' + i" *ngIf="shouldShowRoleColumn">
                    <nz-tag
                      [nzColor]="getEmployeeRole(employee) === 'tenant.employee.role-owner' ? 'gold' : 'blue'"
                      class="role-tag"
                      [class.role-owner]="getEmployeeRole(employee) === 'tenant.employee.role-owner'"
                      [class.role-secretary]="getEmployeeRole(employee) !== 'tenant.employee.role-owner'"
                      [testId]="'tenant-employee-role-tag-' + i"
                    >
                      {{ getEmployeeRole(employee) | i18n }}
                    </nz-tag>
                  </td>
                  <td [testId]="'tenant-employee-cell-inviter-join-time-' + i">
                    <div class="inviter-join-time">
                      <div class="inviter-join-time-source">
                        <a
                          *ngIf="employee.invitedByName"
                          class="inviter-link"
                          nz-tooltip
                          [nzTooltipTitle]="'tenant.employee.inviter-filter-tooltip' | i18n"
                          (click)="filterByInviter(employee.invitedByAccountId, employee.invitedByName)"
                          [testId]="'tenant-employee-inviter-link-' + i"
                        >
                          {{ employee.invitedByName }}
                        </a>
                        <span *ngIf="!employee.invitedByName" class="text-secondary" [testId]="'tenant-employee-inviter-unknown-' + i">
                          -
                        </span>
                      </div>
                      <div class="inviter-join-time-date" [testId]="'tenant-employee-inviter-date-' + i">
                        {{ employee.joinedAt ? (employee.joinedAt | date: 'yyyy-MM-dd HH:mm') : '-' }}
                      </div>
                    </div>
                  </td>
                  <td [testId]="'tenant-employee-cell-status-' + i">
                    <nz-tag
                      [nzColor]="employee.status === 'Enable' ? 'success' : 'default'"
                      class="status-tag"
                      [class.status-active]="employee.status === 'Enable'"
                      [class.status-inactive]="employee.status !== 'Enable'"
                      [testId]="'tenant-employee-status-tag-' + i"
                    >
                      {{
                        employee.status === 'Enable' ? ('tenant.employee.status-active' | i18n) : ('tenant.employee.status-inactive' | i18n)
                      }}
                    </nz-tag>
                  </td>
                  <td
                    *ngIf="!isSelector && !isPersonalTenant && hasPublicIpCapability"
                    class="mobile-access-column"
                    [testId]="'tenant-employee-cell-mobile-access-' + i"
                  >
                    <nz-tag
                      class="mobile-access-tag"
                      [nzColor]="employee.mobileAccessEnabled !== false ? 'green' : 'blue'"
                      [testId]="'tenant-employee-mobile-access-tag-' + i"
                    >
                      {{
                        (employee.mobileAccessEnabled !== false ? 'tenant.employee.access-allow' : 'tenant.employee.access-disable') | i18n
                      }}
                    </nz-tag>
                  </td>
                  <td [class.text-center]="isSelector" [testId]="'tenant-employee-cell-actions-' + i">
                    <button
                      *ngIf="isSelector"
                      nz-button
                      nzType="primary"
                      nzShape="circle"
                      nzSize="small"
                      class="select-btn"
                      [testId]="'tenant-employee-select-btn-' + i"
                      (click)="selectEmployee(employee)"
                    >
                      <i nz-icon nzType="check" [testId]="'tenant-employee-select-icon-' + i"></i>
                    </button>
                    <button
                      *ngIf="shouldShowExitButton(employee)"
                      nz-button
                      nzType="link"
                      nzSize="small"
                      class="action-button delete-button dangerous-action"
                      [testId]="'tenant-employee-exit-btn-' + i"
                      (click)="deleteEmployee(employee)"
                    >
                      <i nz-icon nzType="user-delete" [testId]="'tenant-employee-exit-icon-' + i"></i>
                      {{ 'tenant.employee.exit-team' | i18n }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </nz-table>
          </nz-spin>
        </div>

        <div class="mobile-card-section" [testId]="'tenant-employee-mobile-section'">
          <nz-spin [nzSpinning]="loading" [nzTip]="'common.loading' | i18n">
            <div class="mobile-card-list">
              <div
                class="mobile-employee-card"
                *ngFor="let employee of employeeList; let i = index; trackBy: trackByEmployee"
                [testId]="'tenant-employee-mobile-card-' + i"
              >
                <div class="mobile-card-main">
                  <div class="mobile-card-number" [testId]="'tenant-employee-mobile-number-' + i">{{ i + 1 }}</div>
                  <nz-avatar
                    [nzSrc]="employee.avatarUrl || employee.fallbackAvatarUrl"
                    nzSize="default"
                    class="employee-avatar mobile-avatar"
                    (click)="openImageViewer(employee.avatarUrl, employee)"
                    [testId]="'tenant-employee-mobile-avatar-' + i"
                  >
                    {{ employee.name?.charAt(0) }}
                  </nz-avatar>
                  <div class="mobile-card-content">
                    <div
                      class="mobile-card-name"
                      nz-tooltip
                      [nzTooltipTitle]="employee.name"
                      [testId]="'tenant-employee-mobile-name-' + i"
                      >{{ employee.name }}</div
                    >
                    <div class="mobile-card-meta">
                      <nz-tag
                        *ngIf="shouldShowRoleColumn"
                        [nzColor]="getEmployeeRole(employee) === 'tenant.employee.role-owner' ? 'gold' : 'blue'"
                        class="role-tag"
                        [class.role-owner]="getEmployeeRole(employee) === 'tenant.employee.role-owner'"
                        [class.role-secretary]="getEmployeeRole(employee) !== 'tenant.employee.role-owner'"
                        [testId]="'tenant-employee-mobile-role-tag-' + i"
                      >
                        {{ getEmployeeRole(employee) | i18n }}
                      </nz-tag>
                      <nz-tag
                        [nzColor]="employee.status === 'Enable' ? 'success' : 'default'"
                        class="status-tag"
                        [class.status-active]="employee.status === 'Enable'"
                        [class.status-inactive]="employee.status !== 'Enable'"
                        [testId]="'tenant-employee-mobile-status-tag-' + i"
                      >
                        {{
                          employee.status === 'Enable'
                            ? ('tenant.employee.status-active' | i18n)
                            : ('tenant.employee.status-inactive' | i18n)
                        }}
                      </nz-tag>
                    </div>
                  </div>
                </div>

                <div class="mobile-card-details" [testId]="'tenant-employee-mobile-details-' + i">
                  <div class="mobile-detail-row inviter-join-time-mobile">
                    <span class="detail-label">{{ 'tenant.employee.inviter-join-time' | i18n }}:</span>
                    <span class="detail-value inviter-join-time-mobile" [testId]="'tenant-employee-mobile-inviter-join-time-' + i">
                      <span class="inviter-join-time-source">
                        <a
                          *ngIf="employee.invitedByName"
                          class="inviter-link"
                          (click)="filterByInviter(employee.invitedByAccountId, employee.invitedByName)"
                          [testId]="'tenant-employee-mobile-inviter-link-' + i"
                        >
                          {{ employee.invitedByName }}
                        </a>
                        <span
                          *ngIf="!employee.invitedByName"
                          class="text-secondary"
                          [testId]="'tenant-employee-mobile-inviter-unknown-' + i"
                          >-</span
                        >
                      </span>
                      <span class="inviter-join-time-date" [testId]="'tenant-employee-mobile-inviter-date-' + i">
                        {{ employee.joinedAt ? (employee.joinedAt | date: 'yyyy-MM-dd HH:mm') : '-' }}
                      </span>
                    </span>
                  </div>
                </div>

                <div
                  class="mobile-access-control"
                  *ngIf="!isSelector && !isPersonalTenant && hasPublicIpCapability"
                  [testId]="'tenant-employee-mobile-access-control-' + i"
                >
                  <span>{{ 'tenant.employee.mobile-access-control' | i18n }}</span>
                  <nz-tag
                    class="mobile-access-tag"
                    [nzColor]="employee.mobileAccessEnabled !== false ? 'green' : 'blue'"
                    [testId]="'tenant-employee-mobile-access-tag-card-' + i"
                  >
                    {{
                      (employee.mobileAccessEnabled !== false ? 'tenant.employee.access-allow' : 'tenant.employee.access-disable') | i18n
                    }}
                  </nz-tag>
                </div>

                <div class="mobile-card-actions" *ngIf="isSelector || shouldShowExitButton(employee)">
                  <button
                    *ngIf="isSelector"
                    nz-button
                    nzType="primary"
                    class="mobile-select-btn"
                    [testId]="'tenant-employee-mobile-select-btn-' + i"
                    (click)="selectEmployee(employee)"
                  >
                    <i nz-icon nzType="check" [testId]="'tenant-employee-mobile-select-icon-' + i"></i>
                    {{ 'common.confirm' | i18n }}
                  </button>
                  <button
                    *ngIf="shouldShowExitButton(employee)"
                    nz-button
                    nzType="default"
                    class="mobile-exit-btn dangerous-action"
                    [testId]="'tenant-employee-mobile-exit-btn-' + i"
                    (click)="deleteEmployee(employee)"
                  >
                    <i nz-icon nzType="user-delete" [testId]="'tenant-employee-mobile-exit-icon-' + i"></i>
                    {{ 'tenant.employee.exit-team' | i18n }}
                  </button>
                </div>
              </div>
            </div>

            <div
              class="mobile-load-more-anchor"
              #mobileLoadMoreAnchor
              *ngIf="isMobileView && hasMoreMobile"
              [testId]="'tenant-employee-mobile-load-anchor'"
            >
              <div class="mobile-load-more-indicator" [class.loading]="isLoadingMore"></div>
            </div>
          </nz-spin>
        </div>

        <div class="content-footer" *ngIf="total > 0 && !isMobileView" [testId]="'tenant-employee-content-footer'">
          <div class="pagination-section" [testId]="'tenant-employee-pagination-container'">
            <div class="pagination-info" [testId]="'tenant-employee-pagination-info'">
              {{ 'tenant.employee.total-records' | i18n: { total: total } }}
            </div>
            <div class="pagination-controls" [testId]="'tenant-employee-pagination-controls'">
              <nz-pagination
                [testId]="'tenant-employee-pagination'"
                nzSize="small"
                [nzShowQuickJumper]="false"
                [nzPageIndex]="pageIndex"
                [nzTotal]="total"
                [nzPageSize]="pageSize"
                [nzShowSizeChanger]="false"
                [nzPageSizeOptions]="[10, 20, 50, 100]"
                (nzPageIndexChange)="pageIndexChange($event)"
                (nzPageSizeChange)="pageSizeChange($event)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="hasPublicIpCapability && !isInModal && selectedTabIndex === 1">
    <tenant-ip-range [tenantId]="effectiveTenantId" [testId]="'tenant-employee-ip-range'" />
  </ng-container>
</div>

<image-viewer
  [testId]="'tenant-employee-image-viewer'"
  [(visible)]="imageViewerVisible"
  [imageUrl]="avatarUrl"
  [title]="'tenant.employee.image-preview' | i18n"
  (close)="closeImageViewer()"
/>

<nz-modal
  [(nzVisible)]="batchModalVisible"
  [nzTitle]="'tenant.employee.batch-search' | i18n"
  (nzOnCancel)="closeBatchModal()"
  [nzWidth]="540"
  [testId]="'tenant-employee-batch-modal'"
  [nzFooter]="batchModalFooter"
>
  <ng-container *nzModalContent>
    <div class="batch-modal-content" [testId]="'tenant-employee-batch-modal-content'">
      <textarea
        nz-input
        rows="8"
        [placeholder]="'tenant.employee.batch-search-placeholder' | i18n"
        [ngModel]="batchRawText"
        (ngModelChange)="onBatchRawTextChange($event)"
        class="batch-modal-textarea"
        [testId]="'tenant-employee-batch-textarea'"
      ></textarea>
      <div class="batch-modal-meta">
        <span class="batch-count" [class.exceeded]="batchKeywordsExceeded" [testId]="'tenant-employee-batch-count-indicator'">
          <span *ngIf="!batchKeywordsExceeded">
            {{ 'tenant.employee.batch-count-detected' | i18n: { count: batchKeywordsCount } }}
          </span>
          <span *ngIf="batchKeywordsExceeded" class="text-danger">
            {{ 'tenant.employee.batch-limit-exceeded' | i18n: { count: batchKeywordsCount } }}
          </span>
        </span>
        <button
          nz-button
          nzType="link"
          nzSize="small"
          class="clear-input-btn"
          (click)="clearBatchModalInput()"
          [disabled]="!batchRawText"
          [testId]="'tenant-employee-batch-clear-input-btn'"
        >
          {{ 'tenant.employee.clear-input' | i18n }}
        </button>
      </div>
    </div>
  </ng-container>
  <ng-template #batchModalFooter>
    <button nz-button nzType="default" (click)="closeBatchModal()" [testId]="'tenant-employee-batch-modal-cancel-btn'">
      {{ 'common.cancel' | i18n }}
    </button>
    <button
      nz-button
      nzType="primary"
      (click)="confirmBatchModal()"
      [disabled]="batchKeywordsExceeded || batchKeywordsCount === 0"
      [testId]="'tenant-employee-batch-modal-confirm-btn'"
    >
      {{ 'tenant.employee.batch-search-btn' | i18n }}
    </button>
  </ng-template>
</nz-modal>
